import Vue from 'vue'
import vuetify from 'vuetify'
import App from './App.vue'
import './registerServiceWorker'
import router from './router/index'
import store from './store/index'
import '@mdi/font/css/materialdesignicons.css'
import colors from 'vuetify/lib/util/colors'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';

import VueSession from "vue-session";
Vue.use(VueSession);

import VueNumeric from 'vue-numeric'
Vue.component('vue_numeric', VueNumeric);
// import VueClientRecaptcha from 'vue-client-recaptcha/dist/vue-client-recaptcha.es'
// Vue.component("VueClientRecaptcha", VueClientRecaptcha);
//confirm plugin
import { confirmPlugin } from './plugin/confirm'
import { snackPlugin } from './plugin/notifier'
import {progressPlugin} from './plugin/progress'
// Make BootstrapVue available throughout your project
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(vuetify)
Vue.config.productionTip = false
// Vue.use(VueSweetalert2)
//confirm

Vue.use(confirmPlugin)
Vue.use(snackPlugin)
Vue.use(progressPlugin)
Vue.component('date-picker', VuePersianDatetimePicker);

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.config.productionTip = false



Vue.mixin({
    methods: {
        can: (key) => store.state.permissions.includes(key)
    }
});
new Vue({
    components: {},

  vuetify: new vuetify({
      rtl:true,
      theme: {
              options: {
                  customProperties: true,
              },
              dark: false,
          themes: {
              light: {
                  primary: colors.blue.darken3,
                  secondary: colors.blue.darken4,
                  secondary2: colors.blue.lighten4,
                  success: colors.green.darken3,
                  warning: colors.orange.darken3,
                  error: colors.red.base,
                  accent: colors.indigo.base,
                  accent2: colors.indigo.lighten2,
              },
          },
          },
          icons: {
          iconfont: 'mdi'||'fa'
      },


  }),
  router,
  store,
  render: h => h(App),
}).$mount('#app');


